












































import { defineComponent, PropType, computed, useFetch, ref } from '@nuxtjs/composition-api';
import AppAvatar from '~/components/partials/App/AppAvatar.vue';
import AppContentCardThumbnail from '~/components/partials/App/AppContentCardThumbnail.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useRelatedContents } from '~/composables/contents/useRelatedContents';
import { MAGAZINE_CARD_DESCRIPTION_MAX_COUNT } from '~/constants';
import { THUMBNAIL_300 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import type { ArticleCard, EditorProfile, ArticleCategory, DynamicPartsMagazine } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppLink,
    AppContentCardThumbnail,
    AppAvatar,
    AppIcon,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsMagazine>,
      required: true,
    },
    authors: {
      type: Array as PropType<EditorProfile[]>,
      default: () => [],
    },
    categories: {
      type: Array as PropType<ArticleCategory[]>,
      default: () => [],
    },
  },
  setup(props) {
    const article = ref<ArticleCard>();
    const author = ref<EditorProfile>();
    const category = ref<ArticleCategory>();

    const detailUrl = computed(() => article.value && url('ARTICLE_DETAIL', { permalink: article.value.permalink }));
    const authorUrl = computed(
      () => author.value?.permalink && url('ARTICLE_LIST_AUTHOR', { permalink: author.value.permalink })
    );
    const thumbnailImagePc = computed(() =>
      article.value?.thumbnailImagePc ? article.value.thumbnailImagePc + THUMBNAIL_300 : undefined
    );
    const mainImagePc = computed(() =>
      article.value?.mainImagePc ? article.value.mainImagePc + THUMBNAIL_300 : undefined
    );

    const description = computed(() =>
      article.value?.description && article.value.description.length >= MAGAZINE_CARD_DESCRIPTION_MAX_COUNT
        ? article.value.description.slice(0, MAGAZINE_CARD_DESCRIPTION_MAX_COUNT) + '...'
        : article.value?.description
    );
    const { getRelatedMagazines } = useRelatedContents();

    useFetch(async () => {
      const result = await getRelatedMagazines([props.item.magazine_card_article_id]);

      article.value = result?.articles && result.articles[0];
      category.value = result?.categories.find(({ id }) => article.value && id === Number(article.value.categoryId));
      author.value = result?.authors.find(({ id }) => id === article.value?.authorId);
    });

    return {
      thumbnailImagePc,
      mainImagePc,
      author,
      category,
      detailUrl,
      authorUrl,
      description,
      article,
    };
  },
});
